import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckBranchMoNames } from '@api/consistencyCheck';

import { extractQueryParams } from '@utils/common';

import { ICMMavenirVendor } from '@interfaces/cmModule/cmModule';
import { IComparisonId } from '@interfaces/cmModule/dto/cmModuleDTO';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_SITE_MO_NAMES } from '@constants/queryKeys';

const useQueryConsistencyCheckDetailsMoNames = ({
	comparisonId,
	isMavenirVendor,
}: IComparisonId & ICMMavenirVendor) => {
	const {
		data: moNames,
		isLoading,
		isFetching,
	} = useQuery<string[]>({
		queryKey: [CONSISTENCY_SITE_MO_NAMES, comparisonId],
		queryFn: extractQueryParams(getConsistencyCheckBranchMoNames),
		enabled: [comparisonId, isMavenirVendor],
		...refetchOptions,
	});

	return {
		moNames: moNames || [],
		isLoadingMoNames: (isLoading && !!moNames)
			|| isFetching,
	};
};

export default useQueryConsistencyCheckDetailsMoNames;
